








































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { statusSummaryMap } from '@/utils/finance';
import { dealFinanceFund } from '@/api/finance.js';
import selectMember from '@/components/project/selectMember.vue';
import moment from 'moment';

interface User {
  id: number;
  nickname: string;
}
@Component({
  components: {
    selectMember
  }
})
class EditConfig extends Vue {
  modifyUsers: User[] = [];
  queryUsers: User[] = [];
  statusSummaryMap = statusSummaryMap;
  form: any = {
    manageFee: '', // 填写的时候填小数（小数点后4位），展示百分比
    gpInvest: '', // 数字，带千分位符，保留小数点后2位
    executivePartner: '',
    gpEstablishDate: '', // 日期
    gpRegLocation: '',
    fundManagerFullName: '',
    fundManagerEstablishDate: '', // 日期
    fundManagerRegLocation: '',
    manageFeeDeal: '', // 管理费收取方式
    carryDeal: '', // carry收取方式
    subscriptionScale: undefined // 基金规模（认缴额）
  };

  legalEntityId: number = 0;

  labelCol: object = { span: 7 };
  wrapperCol: object = { span: 14 };

  @Prop()
  visible;

  @Prop()
  type;

  @Prop()
  fund;

  @Watch('fund', { immediate: true })
  fundChange(val) {
    let {
      manageFee,
      gpInvest,
      executivePartner,
      gpEstablishDate,
      gpRegLocation,
      fundManagerFullName,
      fundManagerEstablishDate,
      fundManagerRegLocation,
      manageFeeDeal,
      carryDeal,
      subscriptionScale,
      legalEntityId
    } = val;
    this.form = {
      manageFee,
      gpInvest,
      executivePartner,
      gpEstablishDate: gpEstablishDate ? moment(gpEstablishDate, 'YYYY-MM-DD') : null,
      gpRegLocation,
      fundManagerFullName,
      fundManagerEstablishDate: fundManagerEstablishDate ? moment(fundManagerEstablishDate, 'YYYY-MM-DD') : null,
      fundManagerRegLocation,
      manageFeeDeal,
      carryDeal,
      subscriptionScale
    };
    this.legalEntityId = legalEntityId;
  }

  created() {}

  handleCancel() {
    this.$emit('hide');
  }

  async handleOk() {
    try {
      let res = await dealFinanceFund({
        legalEntityId: this.legalEntityId,
        ...this.form,
        gpEstablishDate: this.form.gpEstablishDate ? this.form.gpEstablishDate.format('YYYY-MM-DD') : '',
        fundManagerEstablishDate: this.form.fundManagerEstablishDate ? this.form.fundManagerEstablishDate.format('YYYY-MM-DD') : '',
        manageFee: this.getBit(this.form.manageFee, 4),
        gpInvest: this.getBit(this.form.gpInvest, 2),
        subscriptionScale: this.getBit(this.form.subscriptionScale, 2)
      });

      if (res.code === 200) {
        this.$message.success('保存成功');
        this.$emit('hide');
        this.$emit('refresh');
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }

  getBit(value, step = 4) {
    if (value) {
      if (step === 2) {
        return `${value}`.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      } else if (step === 4) {
        return `${value}`.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3');
      }
    } else {
      return '';
    }
  }

  formatNum(value, step) {
    if (step === 2) {
      return `${value}`.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/(?<!\..*)\B(?=(\d{3})+(?!\d))/g, ',');
    } else if (step === 4) {
      return `${value}`.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3').replace(/(?<!\..*)\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

  parseNum(value) {
    return value.replace(/\$\s?|(,*)/g, '');
  }

  gpEstablishDateChange(val) {
    this.form.gpEstablishDate = val;
  }

  fundManagerEstablishDateChange(val) {
    this.form.fundManagerEstablishDate = val;
  }
}

export default EditConfig;
